import React from "react";

const MembershipLevelCard = (props) => {
    const {levelData, split = false, bottomData, setIntent, setSelectedMembership, setCartTotal, setActiveScreen} = props;

    if(!levelData) {
        return '';
    }
    
    return (
        <div className={`level-card ${split ? 'level-card--split invert' : ''}`}>
            <div className="level-card__top">
                <h3 className="level-card__title">
                    {levelData.name}
                    <span className="level-card__price">${levelData.offerings[0].priceLists[0].prices[0].price}</span>
                </h3>
                <p className="level-card__details">
                    {levelData.description.replace(/(<([^>]+)>)/gi, '').replace(/\&\S+\;/gi, '&')}
                    <button
                        className="button"
                        onClick={() => {
                            setIntent('Purchase');
                            setSelectedMembership(levelData);
                            setCartTotal(levelData.offerings[0].priceLists[0].prices[0].price);
                            setActiveScreen('selection');
                            window.scrollTo(0, 200);
                        }}
                    >
                        Join
                    </button>
                </p>
            </div>
            {split && <div className="level-card__bottom">
                <h4 className="level-card__title">
                    {bottomData.name}
                    <span className="level-card__price">${bottomData.offerings[0].priceLists[0].prices[0].price}</span>
                </h4>
                <p className="level-card__details">
                    {bottomData.description.replace(/(<([^>]+)>)/gi, '').replace(/\&\S+\;/gi, '&')}
                    <button
                        className="button button--icon-right"
                        onClick={() => {
                            setIntent('Purchase');
                            setSelectedMembership(bottomData);
                            setCartTotal(bottomData.offerings[0].priceLists[0].prices[0].price);
                            setActiveScreen('selection');
                            window.scrollTo(0, 200);
                        }}
                    >
                        Join Plus
                    </button>
                </p>
            </div>}
        </div>
    );

}

export default MembershipLevelCard;